import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import initRedux from './utils/redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react'
import { Provider } from 'react-redux';

const redux = initRedux();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
     <Provider store={redux.store}>
       <PersistGate loading={null} persistor={redux.persistor}>
        <App />
       </PersistGate>
     </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
